import React, { useContext, Suspense, lazy } from "react";
import zhCN from "antd/lib/locale-provider/zh_CN";
import { ConfigProvider } from "@fle-ui/next";
import { BrowserRouter, Route, Switch, } from "react-router-dom";
import { Provider } from "mobx-react";
import moment from "moment";
import "moment/locale/zh-cn";
import { FleErrorBoundary } from '@fle-ui/pro-error-boundary';

// storesS
import commonStore from "./stores/common";
import shopStore from "./stores/shop/shop";
import cateStore from "./stores/shop/cate";
import orderStore from "./stores/shop/order";
import supplierStore from "./stores/user/supplier";
import financeStore from "./stores/finance/finance";
import transactionDetailStore from "./stores/finance/transactionDetail";
import settlementAuditStore from "./stores/finance/settlementAudit";
import liyeOperateStore from "./stores/operate/liye";
import purchaseOperateStore from "./stores/operate/purchase";
import elebuysOperateStore from "./stores/operate/elebuys";
import projectStore from "./stores/project";
import artMaintenanceStore from "./stores/offisetting/artMaintenance";
import SelectStore from "./stores/homeStore";

moment.locale("zh-cn"); // 统一汉化处理

// components
import "./App.scss";
import Basic from "./layout/Basic";
import { prefixCls } from "./theme";
import { BASE_ROUTER } from './config'

const Login = lazy(() => import ("./views/Login"));
const ForgetAccount = lazy(() => import ("./views/Login/forget_account"));
const ForgetInfo = lazy(() => import ("./views/Login/forget_info"));

const stores = {
  commonStore,
  shopStore,
  cateStore,
  supplierStore,
  orderStore,
  transactionDetailStore,
  settlementAuditStore,
  financeStore,
  liyeOperateStore,
  projectStore,
  purchaseOperateStore,
  elebuysOperateStore,
  artMaintenanceStore,
  SelectStore,
};

// url 正则
function App() {
  stores["SelectStore"] = useContext(SelectStore);
  return (
    <div className="App">

      <FleErrorBoundary>
        <Provider { ...stores }>
          <ConfigProvider
            locale={ zhCN }
            prefixCls={ prefixCls }
          >
            <BrowserRouter basename={BASE_ROUTER}>
              <Suspense fallback={ <></> }>
                <Switch>
                  <Route path="/login" exact component={ Login }/>
                  <Route path="/forget/account" exact component={ ForgetAccount }/>
                  <Route path="/forget/info" exact component={ ForgetInfo }/>
                  <Basic/>
                </Switch>
              </Suspense>

            </BrowserRouter>
          </ConfigProvider>
        </Provider>
      </FleErrorBoundary>
    </div>


  );
}

export default App
